import React, { useState } from "react";
import axios from "axios";
import {
  Row,
  Col,
} from "reactstrap";
import Header from "../header/Header.js";
import PageTitle from "../pagetitle/PageTitle.js";
import Scrollbar from "../scrollbar/scrollbar.js";
import Footer from "../../components/footer/Footer";
import Select from "react-select";
import "./RegisterDonorForm.css"; // Import the new CSS file
import { useEffect } from "react";
import {
  FaUser,
  FaIdCard,
  FaPhone,
  FaEnvelope,
  FaGraduationCap,
  FaBuilding,
  FaCalendarAlt,
  FaUsers,
  FaTint,
  FaVenusMars,
  FaHeart,
  FaRegHeart,
  FaMapMarkerAlt,
  FaShieldAlt,
} from "react-icons/fa";

import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

const schoolMapping = {
  SOE: {
    label: "School of Engineering (SOE)",
    departments: [
      { value: "FED", label: "Freshman Engineering (FED)" },
      { value: "FED-1", label: "FED-1" },
      { value: "FED-2", label: "FED-2" },
      { value: "FED-3", label: "FED-3" },
      { value: "FED-4", label: "FED-4" },
      { value: "FED-5", label: "FED-5" },
      { value: "CE", label: "Civil Engineering (CE)" },
      { value: "EEE", label: "Electrical & Electronics Engineering (EEE)" },
      { value: "ME", label: "Mechanical Engineering (ME)" },
      { value: "ECE", label: "Electronics & Communication Engg. (ECE)" },
      { value: "AG.E", label: "Agricultural Engineering (AG.E)" },
      { value: "MI.E", label: "Mining Engineering (MI.E)" },
      { value: "PT", label: "Petroleum Technology (PT)" }
    ]
  },
  SOC: {
    label: "School of Computing (SOC)",
    departments: [
      { value: "CSE", label: "Computer Science & Engineering (CSE)" },
      { value: "IT", label: "Information Technology (IT)" },
      { value: "CA", label: "Computer Applications (CA)" },
      { value: "AIML", label: "AIML (AIML)" }
    ]
  },
  SOB: {
    label: "School of Business (SOB)",
    departments: [
      { value: "MS", label: "Management Studies (MS)" }
    ]
  },
  SOS: {
    label: "School of Sciences (SOS)",
    departments: [
      { value: "FS", label: "Forensic Science (FS)" }
    ]
  },
  SOP: {
    label: "School of Pharmacy (SOP)",
    departments: [
      { value: "DOP", label: "Pharmacy-AUS (DOP)" }
    ]
  },
  "Campus Operations": {
    label: "Campus Operations",
    departments: [
      { value: "ADMIN", label: "Campus Operations" },
      { value: "OFFICE", label: "Office" },
      { value: "LIB", label: "Library" },
      { value: "EXAM", label: "Exam Cell" },
      { value: "ACC", label: "Accounts" },
      { value: "OTH", label: "Others" }
    ]
  }
};

const schoolOptions = Object.entries(schoolMapping).map(([key, value]) => ({
  value: key,
  label: value.label
}));

const allSchoolDepartments = Object.values(schoolMapping).reduce((acc, school) => {
  return [...acc, ...school.departments];
}, []);

function RegisterDonorForm() {
  var { date } = useParams();

//   date = JSON.parse(date);
  // console.log(date);

  // Suppress legacy context warning for this component
  React.useEffect(() => {
    const originalError = console.error;
    console.error = (...args) => {
      const message = args[0];
      if (
        typeof message === 'string' && 
        (message.includes('Legacy context API') || 
         message.includes('componentWillReceiveProps') ||
         message.includes('componentWillUpdate') ||
         message.includes('React.createContext'))
      ) {
        return; // Suppress legacy warnings
      }
      originalError.call(console, ...args);
    };

    return () => {
      console.error = originalError; // Restore original console.error on cleanup
    };
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
      const allowed = sessionStorage.getItem("donorAllowed");

      if (allowed !== "true") {
          navigate("/", { replace: true });
      }
  }, [navigate]);

  const [formData, setFormData] = useState({
    Name: "",
    Rollno: "",
    MobileNumber: "",
    Email: "",
    College: null,
    School: null,
    Department: null,
    Year: null,
    Section: "",

    BloodGroup: null,
    Gender: null,
    NumberOfTimesDonatedInCampus: "",
    NumberOfTimesDonatedOutside: "",
    EventDate: moment(date).format("DD-MM-YYYY"),
    Address: "",
    isStaff: sessionStorage.getItem("donorRole") === "staff",
  });

  const port = process.env.REACT_APP_SERVER_PORT;

  // Fetch venues dynamically based on the date
  // useEffect(() => {
  //   const fetchVenues = async () => {
  //     try {
  //       console.log("Fetching venues for date:", date);
  //       const response = await axios.post(port + "get-venues", { date });

  //       if (response.status === 200 && response.data) {
  //         console.log("Received venues data:", response.data);
  //         setEventColleges(response.data);
  //       } else {
  //         toast.error("No venues found for the selected date.");
  //         setEventColleges([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching venues:", error);
  //       if (error.response?.status === 404) {
  //         toast.error("No events found for the selected date.");
  //       } else {
  //         toast.error("Failed to fetch venues!");
  //       }
  //       setEventColleges([]);
  //     }
  //   };

  //   if (date) {
  //     fetchVenues();
  //   }
  // }, [date, port]); // Runs when `date` changes

  const [eventDate, setEventDate] = useState(null);


    useEffect(() => {
        const fun = (async () => {
            try {
                const response = await axios.get(port + 'get-upcoming-event');

                if (response.status === 200) {
                    setEventDate(response.data);
                }
                console.log(response.data);
            }
            catch(e) {
                console.log(e);
            }
        });
        fun();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // console.log("event date", eventDate.Date);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selectedOption, name) => {
    if (name === "College") {
      const collegeCode = selectedOption?.value || "";
      const isSchoolRequired = collegeCode === "AUS" || collegeCode === "ACET";
      setFormData((prev) => ({
        ...prev,
        College: selectedOption || null,
        School: isSchoolRequired ? prev.School : null,
        Department: null
      }));
    } else if (name === "School") {
      setFormData((prev) => ({
        ...prev,
        School: selectedOption || null,
        Department: null
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: selectedOption || null,
      }));
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#ff3e3e" : "#e4e4e7",
      borderRadius: "10px",
      padding: "5px 6px",
      fontSize: "14.5px",
      backgroundColor: "#fcfcfc",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 62, 62, 0.1)" : "none",
      transition: "all 0.25s ease",
      "&:hover": {
        borderColor: state.isFocused ? "#ff3e3e" : "#fca5a5",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#a1a1aa",
      fontWeight: "400",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#18181b",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#ffffff" : "#18181b",
      backgroundColor: state.isSelected ? "#ff3e3e" : state.isFocused ? "#fff1f2" : "#ffffff",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#ff3e3e",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05)",
      border: "1px solid #e4e4e7",
    }),
  };
  // const port = import.meta.env.REACT_APP_SERVER_PORT;

   

  const handleSubmit = (e) => {

    e.preventDefault();

    // if (!formData.BloodGroup || formData.BloodGroup == "") {
    //   toast.error("Please select Blood Group");
    //   return;
    // }  

    const collegeCode = formData.College?.value || formData.College || "";

    if (!formData.Gender || formData.Gender === "") {
      toast.error("Please select Gender");
      return;
    }
    else if (!formData.College || formData.College === "") {
      toast.error("Please select College");
      return;
    }
    else if (!formData.BloodGroup || formData.BloodGroup === "") {
      toast.error("Please select Blood Group");
      return;
    }
    else if (!formData.Department || formData.Department === "") {
      toast.error("Please select Department");
      return;
    }
    else if (!formData.isStaff && (!formData.Year || formData.Year === "")) {
      toast.error("Please select Passout Year");
      return;
    }

    let resolvedSchool = "";
    const deptValue = formData.Department?.value || formData.Department || "";
    if (deptValue && (collegeCode === "AUS" || collegeCode === "ACET")) {
      for (const [schoolKey, schoolData] of Object.entries(schoolMapping)) {
        if (schoolData.departments.some(d => d.value.toUpperCase() === deptValue.toUpperCase() || d.label.toUpperCase() === deptValue.toUpperCase())) {
          resolvedSchool = schoolKey;
          break;
        }
      }
    }

    const submitData = {
      ...formData,
      College: formData.College?.value || formData.College || "",
      School: resolvedSchool || formData.School?.value || formData.School || "",
      BloodGroup: formData.BloodGroup?.value || "",
      Gender: formData.Gender?.value.trim().toUpperCase() || "",
      Department: formData.Department?.value || formData.Department || "",
      Year: formData.isStaff ? "" : (formData.Year?.value || formData.Year || ""),
      EventDate: eventDate?.Date || "", // Send full EventDate object
      Address: formData.Address || "",
    };

    if (formData.isStaff) {
      delete submitData.Year;
      delete submitData.Section;
    }

    console.log("FormData for submission:", submitData);

    (async () => {
      try {
        const response = await axios.post(
          port + "register-donor",
          submitData
        );

        if (response.status === 200) {
          console.log(response.data);
          toast.success("Registered successfully");
          sessionStorage.removeItem("donorRole");
          sessionStorage.removeItem("donorAllowed");
          sessionStorage.removeItem("registeredDonorData");
          sessionStorage.removeItem("registeredRollNumber");
          sessionStorage.removeItem("registeredCollege");
          setTimeout(() => {navigate("/blooddonation/home");}, 2000);
        } else {
          toast.success("Student data already submitted");
        }
      } catch (error) {
        console.error(
          "Error submitting form:",
          error?.response?.data || error.message
        );
        toast.error("Failed to submit form");
      }
    })();
  };

  // const handleEventSelect = (selectedEvent) => {
  //   // This function is kept for backward compatibility but now uses dynamic data
  //   console.log("Event selected:", selectedEvent);
  // };

  const resetForm = () => {
    window.location.reload();

    // setFormData({
    //     Name: "",
    //     Rollno: "",
    //     MobileNumber: "",
    //     Email: "",
    //     College: null,
    //     Department: "",
    //     Year: "",
    //     Section: "",
    //     BloodGroup: null,
    //     Gender: null,
    //     NumberOfTimesDonatedInCampus: "",
    //     NumberOfTimesDonatedOutside: ""
    // });
  };

  //   const [eventOptions, setEventOptions] = useState([]);

  // const eventOptions = {
  //   colleges: [
  //     {
  //       value: "Aditya University",
  //       label: "Aditya University",
  //       venues: [
  //         {
  //           value: "Cotton Bhavan, Seminar Hall",
  //           label: "Cotton Bhavan, Seminar Hall",
  //           bloodBank: "Satya Surya Blood Bank, RJY",
  //           room: "208",
  //         },
  //         {
  //           value: "Ratan Tata Bhavan, Seminar Hall",
  //           label: "Ratan Tata Bhavan, Seminar Hall",
  //           bloodBank: "Akshaya Blood Bank, KKD",
  //           room: "006",
  //         },
  //         {
  //           value: "KL Rao Bhavan, Seminar Hall",
  //           label: "KL Rao Bhavan, Seminar Hall",
  //           bloodBank: "Rotary Blood Bank, KKD",
  //           room: "101",
  //         },
  //         {
  //           value: "Bill Gates Bhavan, Seminar Hall",
  //           label: "Bill Gates Bhavan, Seminar Hall",
  //           bloodBank: "Dr. YSR Jakkampudi Rammohan Rao Blood Center, RJY",
  //           room: "101",
  //         },
  //       ],
  //     },
  //     {
  //       value: "Aditya College of Engineering & Technology",
  //       label: "Aditya College of Engineering & Technology",
  //       venues: [
  //         {
  //           value: "Visweswaraya Bhavan, Seminar Hall",
  //           label: "Visweswaraya Bhavan, Seminar Hall",
  //           bloodBank: "GGH, KKD",
  //           room: "011",
  //         },
  //         {
  //           value: "C V Raman Bhavan, Seminar Hall",
  //           label: "C V Raman Bhavan, Seminar Hall",
  //           bloodBank: "GGH, Rampachodavaram",
  //           room: "101",
  //         },
  //         {
  //           value: "Ramanujan Bhavan, Seminar Hall",
  //           label: "Ramanujan Bhavan, Seminar Hall",
  //           bloodBank: "Indian Red Cross Society, KKD",
  //           room: "005",
  //         },
  //         {
  //           value: "Newton Bhavan, Seminar Hall",
  //           label: "Newton Bhavan, Seminar Hall",
  //           bloodBank: "Sri Yuvasena Blood Bank, KKD",
  //           room: "201",
  //         },
  //       ],
  //     },
  //     {
  //       value: "Aditya College of Pharmacy",
  //       label: "Aditya College of Pharmacy",
  //       venues: [
  //         {
  //           value: "Seminar Hall",
  //           label: "Seminar Hall",
  //           bloodBank: "Dhanvantary Blood Bank, RJY",
  //           room: "016",
  //         },
  //       ],
  //     },
  //     {
  //       value: "Aditya Polytechnic College",
  //       label: "Aditya Polytechnic College",
  //       venues: [
  //         {
  //           value: "Abdul Kalam Bhavan, Seminar Hall",
  //           label: "Abdul Kalam Bhavan, Seminar Hall",
  //           bloodBank: "Rotary Blood Bank, Peddapuram",
  //           room: "006",
  //         },
  //       ],
  //     },
  //   ],
  // };

  // const [collegeCode, setCollegeCode] = useState("");

  const PORT = process.env.REACT_APP_SERVER_PORT;


  const options = {
    collegeOptions: [
      { value: "AUS", label: "Aditya University" },
      {
        value: "ACET",
        label: "Aditya College of Engineering & Technology",
      },
      {
        value: "ACOP",
        label: "Aditya College of Pharmacy",
      },
      {
        value: "Poly",
        label: "Aditya Polytechnic College",
      },
      {
        value: "Aditya School Of Business",
        label: "Aditya School Of Business",
      },
    ],
    genderOptions: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    bloodGroupOptions: [
      { value: "A+", label: "A+" },
      { value: "A-", label: "A-" },
      { value: "B+", label: "B+" },
      { value: "B-", label: "B-" },
      { value: "O+", label: "O+" },
      { value: "O-", label: "O-" },
      { value: "AB+", label: "AB+" },
      { value: "AB-", label: "AB-" },
      { value: "Unknown", label: "Unknown" },
    ],
    departmentOptions: [
      { value: "CSE", label: "CSE" },
      { value: "ECE", label: "ECE" },
      { value: "EEE", label: "EEE" },
      { value: "ME", label: "ME" },
      { value: "CE", label: "CE" },
      { value: "IT", label: "IT" },
      { value: "AI&DS", label: "AI&DS" },
      { value: "MCA", label: "MCA" },
      { value: "MBA", label: "MBA" },
    ],
    yearOptions: [
      { value: "2024", label: "2024" },
      { value: "2025", label: "2025" },
      { value: "2026", label: "2026" },
      { value: "2027", label: "2027" },
      { value: "2028", label: "2028" },
      { value: "2029", label: "2029" },
      { value: "2030", label: "2030" },
    ]
  };

  const populateForm = (data) => {
    const collegeValue = data.college || data.College || "";
    const selectedCollege = options.collegeOptions.find( 
      (option) => option.value === collegeValue || option.label === collegeValue
    ) || (collegeValue ? { value: collegeValue, label: collegeValue } : null);
    
    const selectedGender = options.genderOptions.find(
      (option) =>
        option.value && data.gender && option.value.toLowerCase() === data.gender.toLowerCase()
    ) || (data.gender ? { value: data.gender, label: data.gender } : null);

    const deptValue = data.branch || data.Department || "";
    const isAUSOrACET = selectedCollege && (selectedCollege.value === "AUS" || selectedCollege.value === "ACET");

    let selectedSchool = null;
    let selectedDept = null;

    if (isAUSOrACET) {
      const schoolVal = data.School || data.school || "";
      if (schoolVal) {
        const foundSchoolKey = Object.keys(schoolMapping).find(
          k => k.toUpperCase() === schoolVal.toUpperCase() || schoolMapping[k].label.toUpperCase() === schoolVal.toUpperCase()
        );
        if (foundSchoolKey) {
          selectedSchool = { value: foundSchoolKey, label: schoolMapping[foundSchoolKey].label };
          if (deptValue) {
            selectedDept = schoolMapping[foundSchoolKey].departments.find(
              (d) => d.value.toUpperCase() === deptValue.toUpperCase() || d.label.toUpperCase() === deptValue.toUpperCase()
            ) || { value: deptValue, label: deptValue };
          }
        }
      }

      if (!selectedSchool && deptValue) {
        for (const [schoolKey, schoolData] of Object.entries(schoolMapping)) {
          const foundDept = schoolData.departments.find(
            (d) => d.value.toUpperCase() === deptValue.toUpperCase() || d.label.toUpperCase() === deptValue.toUpperCase()
          );
          if (foundDept) {
            selectedSchool = { value: schoolKey, label: schoolData.label };
            selectedDept = foundDept;
            break;
          }
        }
      }

      if (!selectedSchool && deptValue) {
        selectedSchool = { value: "Campus Operations", label: schoolMapping["Campus Operations"].label };
        selectedDept = schoolMapping["Campus Operations"].departments.find(
          (d) => d.value.toUpperCase() === deptValue.toUpperCase() || d.label.toUpperCase() === deptValue.toUpperCase()
        ) || { value: deptValue, label: deptValue };
      }
    } else {
      if (deptValue) {
        selectedDept = options.departmentOptions.find(
          (option) => option.value.toUpperCase() === deptValue.toUpperCase()
        ) || (deptValue ? { value: deptValue, label: deptValue } : null);
      }
    }

    const yearValue = data.relievedyear || data.Year || "";
    const selectedYear = options.yearOptions.find(
      (option) => String(option.value) === String(yearValue)
    ) || (yearValue ? { value: String(yearValue), label: String(yearValue) } : null);

    const isStaff = data.isStaff || sessionStorage.getItem("donorRole") === "staff";
    let address = data.Address || data.address || data.facultyAddress || "";
    if (!address) {
      if (!isStaff) {
        const parts = [data.village, data.mandal, data.district].filter(Boolean).map(p => p.trim());
        address = parts.join(", ");
      } else {
        address = (data.padoorno ? `${data.padoorno || ""}, ${data.pastreet || ""}, ${data.village || ""}, ${data.mandal || ""}.`.trim() : "");
      }
    }

    setFormData({
      ...data,
      Name: data.studentname || data.facultyName || data.Name || "",
      Rollno: data.rollno || data.facultyId || data.Rollno || "",
      MobileNumber: data.mobilenumber || data.facultyMobile || data.MobileNumber || "",
      Email: data.emailid || data.facultyEmail || data.Email || (isStaff ? "" : `${data.rollno || data.Rollno || ""}@adityauniversity.in`),
      School: selectedSchool,
      Department: selectedDept,
      Year: selectedYear,
      Section: data.section || data.Section || "",
      College: selectedCollege,
      Gender: selectedGender,
      BloodGroup: data.bloodgroup ? { value: data.bloodgroup, label: data.bloodgroup } : data.BloodGroup ? { value: data.BloodGroup, label: data.BloodGroup } : null,
      Address: address,
      isStaff: isStaff,
    });
  };

  const autoFetchDetails = async (roll) => {
    try {
      const isStaff = sessionStorage.getItem("donorRole") === "staff";
      const endpoint = isStaff ? "get-staff-data" : "get-student-data";
      const response = await axios.get(
        `${PORT}${endpoint}/${roll.trim().toUpperCase()}`
      );
      
      if (response.data[0]) {
        populateForm(response.data[0]);
      } else {
        toast.error("Details not found!");
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to fetch details!");
    }
  };

  useEffect(() => {
    const savedData = sessionStorage.getItem("registeredDonorData");
    const savedRoll = sessionStorage.getItem("registeredRollNumber");
    
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        if (parsed && typeof parsed === 'object') {
          populateForm(parsed);
        }
      } catch (e) {
        console.error("Error parsing saved donor data:", e);
      }
    } else if (savedRoll) {
      autoFetchDetails(savedRoll);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //     const fetchVenues = async () => {
  //         try {
  //             const response = await axios.post(port + "get-venues", { date });

  //             if (response.status === 200 && response.data.Place) {
  //                 // Map the Place array to the venue options
  //                 const formattedVenues = response.data.Place.map((venue) => ({
  //                     value: venue,
  //                     label: venue,
  //                 }));

  //                 setVenueOptions(formattedVenues); // Update the venue options
  //             } else {
  //                 toast.error("No venues found for the selected date.");
  //                 setVenueOptions([]); // Reset venue options
  //             }
  //         } catch (error) {
  //             console.error("Error fetching venues:", error);
  //             toast.error("Failed to fetch venues!");
  //         }
  //     };

  //     fetchVenues();
  // }, [date]); // Runs when `date` changes

  return (
    <>
      <Toaster />
      <div className="register-donor-page-wrapper">
        <Header hclass={'header--styleFour'} />
        <PageTitle pageTitle={'Register now'} pagesub={'register'} />
        
        {/* Decorative background components */}
        <div className="decor-blob-left"></div>
        <div className="decor-dots-left"></div>
        <div className="decor-drop-right">
          <svg width="120" height="160" viewBox="0 0 100 130" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 10C50 10 90 55 90 85C90 107.091 72.0914 125 50 125C27.9086 125 10 107.091 10 85C10 55 50 10 50 10Z" stroke="#ffd2d7" strokeWidth="2.5" />
            <path d="M50 102C45.5 97.5 41 93 41 88.5C41 84 44.5 80.5 49 80.5C50 80.5 51 81.5 52 82.5C53 81.5 54 80.5 55 80.5C59.5 80.5 63 84 63 88.5C63 93 58.5 97.5 55 102L50 105.5L45.5 102Z" stroke="#ffd2d7" strokeWidth="2.5" />
          </svg>
        </div>
        <div className="decor-dots-right"></div>

        <main>
          <div className="student-form-container">
            <div className="student-blood-donation-form">
                  
                  {/* Form Header */}
                  <div className="form-header-section">
                    <div className="form-header-icon-wrapper">
                      <svg className="form-header-drop-icon" viewBox="0 0 30 42" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 0C15 0 30 16.5 30 27C30 35.2843 23.2843 42 15 42C6.71573 42 0 35.2843 0 27C0 16.5 15 0 15 0Z" />
                      </svg>
                      <div className="form-header-plus-icon">+</div>
                    </div>
                    <h2 className="form-header-title">
                      {formData.isStaff ? "Staff Blood Donation Form" : "Student Blood Donation Form"}
                    </h2>
                    <p className="form-header-subtitle">
                      Your donation can save up to <span className="text-red">3 lives</span>. Thank you for being a lifesaver!
                    </p>
                  </div>

                  {/* Decorative split line */}
                  <div className="decorator-line-container">
                    <span className="line line-red"></span>
                    <span className="heart-icon-middle"><FaHeart /></span>
                    <span className="line line-grey"></span>
                  </div>

                  <form onSubmit={handleSubmit}>
                    
                    {/* Full Name & Roll Number */}
                    <Row className="form-row">
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaUser className="label-icon" /> Full Name <span className="required-star">*</span>
                          </label>
                          <input
                            name="Name"
                            value={formData.Name}
                            placeholder="Enter your full name"  
                            onChange={handleInputChange}
                            required
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaIdCard className="label-icon" /> {formData.isStaff ? "Employee ID" : "Roll Number"} <span className="required-star">*</span>
                          </label>
                          <input
                            name="Rollno"
                            value={formData.Rollno}
                            placeholder={formData.isStaff ? "Enter your employee ID" : "Enter your roll number"}
                            onChange={handleInputChange}
                            required
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Mobile Number & Email */}
                    <Row className="form-row">
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaPhone className="label-icon" /> Mobile Number <span className="required-star">*</span>
                          </label>
                          <input
                            name="MobileNumber"
                            value={formData.MobileNumber}
                            placeholder="Enter mobile number"
                            type="tel"
                            onChange={handleInputChange}
                            required
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaEnvelope className="label-icon" /> Email <span className="required-star">*</span>
                          </label>
                          <input
                            name="Email"
                            value={formData.Email}
                            placeholder="Enter email address"
                            type="email"
                            onChange={handleInputChange}
                            required
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* College & Department */}
                    <Row className="form-row">
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaGraduationCap className="label-icon" /> College <span className="required-star">*</span>
                          </label>
                          <Select
                            options={options.collegeOptions}
                            placeholder="Select College"
                            value={formData.College}
                            onChange={(selected) =>
                              handleSelectChange(selected, "College")
                            }
                            styles={customStyles}
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaBuilding className="label-icon" /> Department <span className="required-star">*</span>
                          </label>
                          <Select
                            options={formData.College && (formData.College.value === "AUS" || formData.College.value === "ACET") ? allSchoolDepartments : options.departmentOptions}
                            placeholder="Select Department"
                            value={formData.Department}
                            onChange={(selected) =>
                              handleSelectChange(selected, "Department")
                            }
                            styles={customStyles}
                            required
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Passout Year & Section (For Students Only) */}
                    {!formData.isStaff && (
                      <Row className="form-row">
                        <Col md={6}>
                          <div className="form-group-custom">
                            <label className="form-label-custom">
                              <FaCalendarAlt className="label-icon" /> Passout Year <span className="required-star">*</span>
                            </label>
                            <Select
                              options={options.yearOptions}
                              placeholder="Select Year"
                              value={formData.Year}
                              onChange={(selected) =>
                                handleSelectChange(selected, "Year")
                              }
                              styles={customStyles}
                              required
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group-custom">
                            <label className="form-label-custom">
                              <FaUsers className="label-icon" /> Section <span className="required-star">*</span>
                            </label>
                            <input
                              name="Section"
                              value={formData.Section}
                              placeholder="Enter section"
                              onChange={handleInputChange}
                              required
                              className="form-input-custom"
                            />
                          </div>
                        </Col>
                      </Row>
                    )}

                    {/* Blood Group & Gender */}
                    <Row className="form-row">
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaTint className="label-icon" /> Blood Group <span className="required-star">*</span>
                          </label>
                          <Select
                            options={options.bloodGroupOptions}
                            placeholder="Select Blood Group"
                            value={formData.BloodGroup}
                            onChange={(selected) =>
                              handleSelectChange(selected, "BloodGroup")
                            }
                            styles={customStyles}
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaVenusMars className="label-icon" /> Gender <span className="required-star">*</span>
                          </label>
                          <Select
                            options={options.genderOptions}
                            placeholder="Select Gender"
                            value={formData.Gender}
                            onChange={(selected) =>
                              handleSelectChange(selected, "Gender")
                            }
                            styles={customStyles}
                            required
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Times Donated In Campus & Times Donated Outside */}
                    <Row className="form-row" style={{ marginBottom: "24px" }}>
                      <Col md={6} className="form-group-custom">
                        <div className="donation-card-input">
                          <div className="donation-card-icon">
                            <FaRegHeart className="heart-icon-outline" />
                          </div>
                          <div className="donation-card-content">
                            <span className="donation-card-label">Times Donated In Campus</span>
                            <input
                              name="NumberOfTimesDonatedInCampus"
                              value={formData.NumberOfTimesDonatedInCampus}
                              placeholder="Enter times donated in campus"
                              type="number"
                              min="0"
                              step="1"
                              onChange={handleInputChange}
                              required
                              className="donation-card-field"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6} className="form-group-custom">
                        <div className="donation-card-input">
                          <div className="donation-card-icon">
                            <FaRegHeart className="heart-icon-outline" />
                          </div>
                          <div className="donation-card-content">
                            <span className="donation-card-label">Times Donated Outside</span>
                            <input
                              name="NumberOfTimesDonatedOutside"
                              value={formData.NumberOfTimesDonatedOutside}
                              placeholder="Enter times donated outside campus"
                              type="number"
                              min="0"
                              step="1"
                              onChange={handleInputChange}
                              required
                              className="donation-card-field"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Event Date & Address (Required fields but styled to blend in) */}
                    <Row className="form-row">
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaCalendarAlt className="label-icon" /> Event Date
                          </label>
                          <input
                            name="Event Date"
                            value={eventDate?.Date ? moment(eventDate.Date).format("DD-MM-YYYY") : ""}
                            readOnly
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group-custom">
                          <label className="form-label-custom">
                            <FaMapMarkerAlt className="label-icon" /> Address <span className="required-star">*</span>
                          </label>
                          <input
                            name="Address"
                            value={formData.Address}
                            placeholder="Enter Address"
                            onChange={handleInputChange}
                            required
                            className="form-input-custom"
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Submit Button & Disclaimer */}
                    <div className="submit-btn-container">
                      <button className="submit-button-full" type="submit">
                        <FaTint className="button-icon-drop" /> SUBMIT FORM
                      </button>
                      <button className="reset-button-subtle" type="button" onClick={resetForm}>
                        Reset Form
                      </button>
                    </div>

                    <div className="info-alert-footer">
                      <FaShieldAlt className="alert-icon" />
                      <span>Your information is safe with us and will only be used for blood donation purposes.</span>
                    </div>

                  </form>
            </div>
          </div>
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </>
  );
}

export default RegisterDonorForm;
